import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { AlertDialogProps } from '@radix-ui/react-alert-dialog'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/shared/ui/Dialog/Dialog'
import { ChangeDefaultManagerForm } from '@/features/DefaultManager/ui/ChangeDefaultManagerForm'

type ChangeDefaultManagerModalProps = {
  dialogProps: AlertDialogProps
  onCloseModal: () => void
}

export const ChangeDefaultManagerModal: FC<ChangeDefaultManagerModalProps> = props => {
  const { dialogProps, onCloseModal } = props
  const { t } = useTranslation(['common'])
  return (
    <Dialog {...dialogProps}>
      <DialogContent className={'overflow-y-auto max-h-[95vh]'}>
        <DialogHeader>
          <DialogTitle>{t('common:library_items.default_manager.change_manager')}</DialogTitle>
          <ChangeDefaultManagerForm onCloseModal={onCloseModal} />
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}
